import { render, staticRenderFns } from "./Overduesubmit.vue?vue&type=template&id=519a51ce&scoped=true"
import script from "./Overduesubmit.vue?vue&type=script&lang=js"
export * from "./Overduesubmit.vue?vue&type=script&lang=js"
import style0 from "./Overduesubmit.vue?vue&type=style&index=0&id=519a51ce&prod&scoped=true&lang=css"
import style1 from "./Overduesubmit.vue?vue&type=style&index=1&id=519a51ce&prod&lang=css"
import style2 from "./Overduesubmit.vue?vue&type=style&index=2&id=519a51ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519a51ce",
  null
  
)

export default component.exports